import {
  annahmeverzugSchema,
  hauptantragArraySchema,
  nebenantragSchema,
} from "~/domains/geldEinklagen/anwaltschaft/hauptUndNebenantraege/hauptUndNebenantraegeSchemas";
import type { PagesConfig } from "~/domains/pageSchemas";

export const hauptUndNebenantraegePages = {
  hauptantragUebersicht: {
    stepId:
      "/haupt-und-nebenantraege/allgemeine-zahlungs-und-nebenantraege/uebersicht",
    arraySummary: {
      name: "hauptantrag",
      schema: hauptantragArraySchema,
      isArrayRelevant: () => true,
    },
  },
  hauptantragDaten: {
    stepId:
      "/haupt-und-nebenantraege/allgemeine-zahlungs-und-nebenantraege/hauptantrag/#/daten",
    shouldCollapseIntoParentNavItem: true,
    pageSchema: {
      "hauptantrag#internesSchlagwortFordureung":
        hauptantragArraySchema.element.shape.internesSchlagwortFordureung,
      "hauptantrag#betragForderung":
        hauptantragArraySchema.element.shape.betragForderung,
      "hauptantrag#beklagte": hauptantragArraySchema.element.shape.beklagte,
      "hauptantrag#klagende": hauptantragArraySchema.element.shape.klagende,
      "hauptantrag#zugUndZug": hauptantragArraySchema.element.shape.zugUndZug,
      "hauptantrag#beschreibungDerGegenleistung":
        hauptantragArraySchema.element.shape.beschreibungDerGegenleistung,
      "hauptantrag#zinssatzInProzent":
        hauptantragArraySchema.element.shape.zinssatzInProzent,
      "hauptantrag#zinsmethode":
        hauptantragArraySchema.element.shape.zinsmethode,
      "hauptantrag#zinsbeginn": hauptantragArraySchema.element.shape.zinsbeginn,
      "hauptantrag#zinsende": hauptantragArraySchema.element.shape.zinsende,
    },
  },
  hauptantragWarnung: {
    stepId:
      "/haupt-und-nebenantraege/allgemeine-zahlungs-und-nebenantraege/warnung",
    shouldCollapseIntoParentNavItem: true,
  },
  nebenantragDaten: {
    stepId:
      "/haupt-und-nebenantraege/allgemeine-zahlungs-und-nebenantraege/#/nebenantrag/#/daten",
    shouldCollapseIntoParentNavItem: true,
    pageSchema: {
      "hauptantrag#nebenantrag#nebenantragArt":
        nebenantragSchema.shape.nebenantragArt,
      "hauptantrag#nebenantrag#nebenantragBetrag":
        nebenantragSchema.shape.nebenantragBetrag,
      "hauptantrag#nebenantrag#nebenantragZinssatzInProzent":
        nebenantragSchema.shape.nebenantragZinssatzInProzent,
      "hauptantrag#nebenantrag#nebenantragZinsmethode":
        nebenantragSchema.shape.nebenantragZinsmethode,
      "hauptantrag#nebenantrag#nebenantragZinsbeginn":
        nebenantragSchema.shape.nebenantragZinsbeginn,
      "hauptantrag#nebenantrag#nebenantragZinsende":
        nebenantragSchema.shape.nebenantragZinsende,
    },
  },
  annahmeverzugDaten: {
    stepId:
      "/haupt-und-nebenantraege/allgemeine-zahlungs-und-nebenantraege/#/annahmeverzug/#/daten",
    shouldCollapseIntoParentNavItem: true,
    pageSchema: {
      "hauptantrag#nebenantrag#annahmeverzugsFeststellung":
        annahmeverzugSchema.shape.annahmeverzugsFeststellung,
      "hauptantrag#nebenantrag#annahmeverzugDatum":
        annahmeverzugSchema.shape.annahmeverzugDatum,
    },
  },
} as const satisfies PagesConfig;
